module.exports = __webpack_public_path__ + "static/media/logout.dd3f380b.svg";